import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Loader from "../../components/ui/loader";

const GoogleCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const handleGoogleCallback = async () => {
      try {
        // Get the token from URL parameters
        const token = searchParams.get("token");
        const error = searchParams.get("error");

        if (error) {
          console.error("Google OAuth error:", error);
          // Redirect to login with error message
          navigate("/login", {
            state: { error: "Google authentication failed" },
          });
          return;
        }

        if (!token) {
          console.error("No token received from Google OAuth");
          navigate("/login", {
            state: { error: "Authentication failed: No token received" },
          });
          return;
        }

        // In a real implementation, you would verify the token with your backend
        // For now, we'll assume the token is valid and try to get user info
        try {
          const response = await fetch("/api/expense-loop/auth/me", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if (response.ok) {
            const userData = await response.json();

            // Store the token and user data in auth context
            login(userData, token);

            // Redirect to dashboard
            navigate("/dashboard");
          } else {
            console.error("Failed to fetch user data with Google token");
            navigate("/login", {
              state: { error: "Failed to authenticate with Google" },
            });
          }
        } catch (fetchError) {
          console.error("Error fetching user data:", fetchError);
          navigate("/login", { state: { error: "Authentication failed" } });
        }
      } catch (error) {
        console.error("Google callback error:", error);
        navigate("/login", {
          state: { error: "An error occurred during authentication" },
        });
      }
    };

    handleGoogleCallback();
  }, [searchParams, navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Loader className="mx-auto mb-4" />
        <p className="text-lg text-muted-foreground">
          Completing Google authentication...
        </p>
      </div>
    </div>
  );
};

export default GoogleCallback;
